import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    cartList: [],
    token: localStorage.getItem('token') || ''
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    CLEAR_USER_INFO(state) {
      state.userInfo = null
      state.token = ''
      localStorage.removeItem('token')
    },
    ADD_TO_CART(state, product) {
      const existing = state.cartList.find(item => item.id === product.id)
      if (existing) {
        existing.quantity += 1
      } else {
        state.cartList.push({ ...product, quantity: 1 })
      }
    },
    REMOVE_FROM_CART(state, productId) {
      state.cartList = state.cartList.filter(item => item.id !== productId)
    },
    UPDATE_CART_QUANTITY(state, { productId, quantity }) {
      const product = state.cartList.find(item => item.id === productId)
      if (product) {
        product.quantity = quantity
      }
    }
  },
  actions: {
    login({ commit }, { token, userInfo }) {
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
    },
    logout({ commit }) {
      commit('CLEAR_USER_INFO')
    },
    addToCart({ commit }, product) {
      commit('ADD_TO_CART', product)
    },
    removeFromCart({ commit }, productId) {
      commit('REMOVE_FROM_CART', productId)
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    cartTotal: state => state.cartList.reduce((total, item) => total + item.quantity, 0),
    cartTotalPrice: state => state.cartList.reduce((total, item) => total + (item.price * item.quantity), 0)
  }
})